export const EPOM_FETCH_URL = 'https://aj2543.bid/bebfc-api-v3';

export const REWARD_WAS_CLOSED = 0;
export const REWARD_RECEIVED = 1;
export const REWARD_FAILED = 2;
export const REWARD_EMPTY = 3;
export const REWARD_SKIP = 4;

export const DEV_MODE_REWARD_DELAY_MS = 100;
export const AD_UPDATE_CHECK_DELAY_MS = 1850;
export const MIN_SIDE_CONTAINER_WIDTH_NARROW = 190;
export const MAX_SIDE_CONTAINER_WIDTH_NARROW = 350;
export const MIN_WINDOW_HEIGHT_FOR_SIDE_BANNERS = 620;

/** Sentry customName for Epom banner load failures. */
export const EPOM_BANNER_LOAD_ERROR = 'AdsError: EpomBannerLoad';
/** Sentry customName for Epom rewarded provider init failures. */
export const EPOM_REWARD_INIT_ERROR = 'AdsError: EpomRewardInit';
/** Sentry customName for VLI banner display failures. */
export const VLI_BANNER_LOAD_ERROR = 'AdsError: VliBannerLoad';
/** Sentry customName for VLI rewarded ad call failures. */
export const VLI_REWARD_LOAD_ERROR = 'AdsError: VliRewardLoad';
/** Sentry customName for VLI provider init failures. */
export const VLI_PROVIDER_INIT_ERROR = 'AdsError: VliProviderInit';
/** Sentry customName for VLI SDK script load failures. */
export const VLI_SDK_LOAD_ERROR = 'AdsError: VliSdkLoad';
/** Sentry customName for unhandled third-party ad SDK window/rejection errors. */
export const ADS_SDK_UNHANDLED_ERROR = 'AdsError: AdSdkUnhandled';

export const NO_GAME_SCREEN_MESSAGE =
    'Unavailable game screen when show ad banner: ';
export const PROVIDER_IS_NOT_SETUP =
    'Ad was called, but events are not initialized for this provider. "*-providers" parameter in the offer should be updated.';

export const USER_ENGAGEMENT_STATUSES = ['non', 'push', 'pwa', 'push-pwa'];
export const GAME_KEYS = {
    KICKANDBOOM: 'kickandboom',
    BACANAGOL: 'bacanagol',
};
export const AD_TYPES = {
    'center': '300x250',
    'center-right': '300x250',
    'footer': '320x50',
    'narrow': '160x600',
    'wide': '300x600',
};
export const PROVIDER_GA_LABEL = {
    vli: 'VLI',
    epom: 'Epom',
    adinplay: 'Adinplay',
};
